<template>
  <q-page padding>
    <div class="row col-12 align">
      <p class="text-h6 text-brand-1 text-weight-bold">Pedido de Compras</p>
    </div>
    <div class="q-ml-md">
      <div class="row col-12 q-gutter-md q-mt-md">
        <q-btn
          label="Criar Novo Pedido de Compra"
          icon="add"
          style="border-radius: 8px; background-color: #21324a; color: white"
          no-caps
          @click="rota('compras-criar', 1)"
        />
        <q-btn
          label="Ver Produtos"
          icon="sym_o_add_box"
          style="border-radius: 8px; background-color: #304f78; color: white"
          no-caps
          @click="rota('compras-pedidos-abertos', 1)"
        />
      </div>
      <div class="q-mt-lg">
        <div
          style="font-size: 16px"
          class="q-mb-lg text-brand-1 text-weight-medium"
        >
          <span>Utilize os campos para filtrar a lista de pedidos.</span>
        </div>
        <section
          class="row col-12 q-mt-sm q-gutter-sm text-brand-1 text-weight-bold"
        >
          <div class="col-md-3">
            <div class="q-ml-sm">Unidade</div>
            <lista-unidades-select v-model="unidade"></lista-unidades-select>
          </div>

          <div class="col-md-3">
            <div class="q-ml-sm">Fornecedor</div>
            <q-input
              outlined
              dense
              v-model="fornecedor"
              placeholder="Fornecedor"
            >
            </q-input>
          </div>

          <div class="col-md">
            <div class="q-ml-sm">Numero Pedido</div>
            <q-input
              outlined
              dense
              v-model="numero"
              placeholder="Num. Pedido"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            >
            </q-input>
          </div>

          <div class="col-md">
            <div class="q-ml-sm">Status Pedido</div>
            <q-select
              :options="status_pedido"
              label="Status Pedido"
              dense
              outlined
              v-model="status"
              :rules="[(val) => !!val || 'Campo Obrigatório']"
            />
          </div>

          <div class="col-md">
            <div class="q-ml-sm">Status Aprovação</div>
            <q-select
              :options="status_aprovacao"
              label="Status Aprovação"
              dense
              outlined
              v-model="aprovacao"
              :rules="[(val) => !!val || 'Campo Obrigatório']"
            />
          </div>
        </section>
      </div>
    </div>
    <q-table
      flat
      table-header-style="background-color: #d9effc"
      :rows="rows"
      :columns="columns"
      dense
      color="primary"
      class="tabela-tamanho-fixo"
      :loading="disable"
      title-class="text-brand-5 text-weight-bold"
      hide-pagination
      v-model:pagination="pagination"
      :rows-per-page-options="[0]"
      @request="handleRequest"
    >
      <template #body-cell-solicitante_nome="props">
        <q-td>
          <div class="row">
            <span>
              {{ props.row.solicitante_nome }}
            </span>
            <span> ( {{ props.row.solicitante_matricula }}) </span>
          </div>
        </q-td>
      </template>
      <template #body-cell-cost_center_code="props">
        <q-td>
          <div class="row">
            <span>
              {{ props.row.cost_center_code }}
            </span>
            <span class="row"> ({{ props.row.cost_center_name }}) </span>
          </div>
        </q-td>
      </template>
      <template #body-cell-fornecedor="props">
        <q-td>
          <span class="text-brand-5 text-weight-bold">{{
            props.row?.provider?.business_name
          }}</span>
        </q-td>
      </template>
      <template #body-cell-receber="props">
        <q-td>
          <q-btn
            :disable="props.row.products.length == 0"
            round
            :color="props.row.products.length == 0 ? 'grey' : 'positive'"
            icon="sym_o_done_outline"
            flat
            @click="rota('compras-receber', props.row.id)"
          />
        </q-td>
      </template>
      <template #body-cell-deletar="props">
        <q-td>
          <q-btn
            @click="confirmarDeletar(props.row.id)"
            icon="sym_o_delete"
            round
            color="negative"
            flat
          />
        </q-td>
      </template>
      <template #body-cell-imprimir="props">
        <q-td>
          <q-btn
            @click="rota('compras-imprimir-pedidos', props.row.id)"
            icon="sym_o_print"
            round
            color="black"
            flat
          />
        </q-td>
      </template>
      <template #body-cell-editar="props">
        <q-td>
          <q-btn
            @click="rota('compras-editar', props.row.id)"
            icon="sym_o_edit"
            round
            color="primary"
            flat
          />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>

    <DialogConfirmDesign
      :exibir="modalDeletar"
      mensagem="Tem certeza que deseja deletar este pedido? Essa ação é irreversivel"
      @resultado="handleDeletarConfirmacao"
    />
  </q-page>
</template>

<script>
// funçao para formatar preço no padrão brasileiro (sempre 2 casas decimais)
const formatPreco = (value) => {
  if (!value && value !== 0) return "R$ 0,00";
  const num = Number(value);
  if (isNaN(num)) return "R$ 0,00";

  return `R$ ${num.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const columns = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "unidade",
    label: "Unidade",
    field: (row) => row.vendor.name,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "urgencia",
    label: "Urgência",
    field: (row) => (row.tag && row.tag.nome ? row.tag.nome : ""),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "criacao",
    label: "Criação",
    field: (row) => row.created_at.split(" ")[0].split("-").reverse().join("/"),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "fornecedor",
    label: "Fornecedor",
    field: (row) =>
      row.provider && row.provider.business_name
        ? row.provider.business_name
        : "Sem Fornecedor",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "total_ordem",
    label: "Total da Ordem",
    field: (row) => formatPreco(row.total_produtos),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "status",
    label: "Pedido",
    field: (row) => row.status,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "aprovacao",
    label: "Aprovação",
    field: (row) => row.aprovacao,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "numero_pedidos",
    label: "Nº de itens",
    field: (row) => row.products.length,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "editar",
    label: "Editar",
    field: "editar",
    align: "left",
  },
  {
    name: "receber",
    label: "Receber",
    field: "receber",
    align: "left",
  },
  {
    name: "deletar",
    label: "Deletar",
    field: "deletar",
    align: "left",
  },
  {
    name: "imprimir",
    label: "Imprimir",
    field: "imprimir",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";

export default {
  components: { ListaUnidadesSelect, DialogConfirmDesign },
  setup() {
    const router = useRouter();
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const status = ref("Todos");
    const aprovacao = ref("Todos");
    const numero = ref("");
    const unidade = ref();
    const fornecedor = ref("");
    const modalDeletar = ref(false);
    const idParaDeletar = ref(null);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 10) => {
      store.dispatch("pdt/hiddenHeader", true);
      try {
        const response = await store.dispatch("compras/listarPedidos", {
          vendor_id: store.state.org.unidadeData.id,
          page,
          per_page: rowsPerPage,
          status_aprovacao: aprovacao.value.value,
          status: status.value.value,
          provider: fornecedor.value,
          id: numero.value,
        });

        rows.value = response.data.results.data;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro ao encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const rota = async (rota, param = "") => {
      if (param != "") {
        router.push({
          name: rota,
          params: { id: param },
        });
      } else {
        router.push({
          name: rota,
        });
      }
    };

    const confirmarDeletar = (id) => {
      idParaDeletar.value = id;
      modalDeletar.value = true;
    };

    const handleDeletarConfirmacao = async (confirmado) => {
      modalDeletar.value = false;
      if (confirmado) {
        await deletar(idParaDeletar.value);
      }
      idParaDeletar.value = null;
    };

    const deletar = async (id) => {
      try {
        await store.dispatch("compras/deletarPedido", {
          id: id,
        });

        $q.notify({
          message: "Deletado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro ao deletar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => aprovacao.value,
      () => {
        disable.value = true;
        handleRequest();
      }
    );
    watch(
      () => status.value,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => numero.value,
      () => {
        getDados();
      }
    );

    watch(
      () => fornecedor.value,
      () => {
        getDados();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      pagination,
      rows,
      disable,
      columns,
      getDados,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),

      aprovacao,
      rota,
      status_pedido: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "Criado",
          value: "Criado",
        },
        {
          label: "Enviado",
          value: "Enviado",
        },
        {
          label: "Recebido Parcialmente",
          value: "recebido_parcialmente",
        },
        {
          label: "Recebido Totalmente",
          value: "recebido",
        },
        {
          label: "Atrasado",
          value: "atrasado",
        },
      ],
      status_aprovacao: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "Aprovado",
          value: "aprovado",
        },
        {
          label: "Não Iniciado",
          value: "pendente",
        },
        {
          label: "Aguardando",
          value: "aguardando",
        },
        {
          label: "Reprovado",
          value: "reprovado",
        },
      ],

      status,
      numero,
      deletar,
      fornecedor,
      unidade,
      formatPreco,
      modalDeletar,
      confirmarDeletar,
      handleDeletarConfirmacao,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}
.no-wrap {
  flex-wrap: nowrap !important;
}
tbody tr td {
  white-space: pre-wrap;
}
.colorHeaderTabela {
  background-color: #d9effc;
}
</style>
